var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreeDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 19,
    viewBox: "0 0 6 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.00028,
    cy: 3.00028,
    r: 2.14286,
    fill: "#183243"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.00028,
    cy: 9.8577,
    r: 2.14286,
    fill: "#183243"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.00028,
    cy: 16.7141,
    r: 2.14286,
    fill: "#183243"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDots);
export default __webpack_public_path__ + "static/media/three_dots.5330b7b495be6c1cab37a22800709e0b.svg";
export { ForwardRef as ReactComponent };